/**
 * Parse query string to key value pairs.
 * This function is intended to be used directly with values from window.location.search.
 * No need to strip out leading '?' and it will decode URI
 *
 * @Example:
 * '?a=1&b=2' ---> {a: 1, b: 2}
 *
 * leading '?' is optional which means:
 * 'a=1&b=2' ---> {a: 1, b: 2}
 *
 * @param {String}  queryString
 * @return {Object}
 */
import _ from 'lodash';

export default function parseQueryString(queryString) {
  if (typeof queryString !== 'string') {
    throw new TypeError('queryString must be a string.');
  }
  if (queryString === '') {
    return {};
  }

  return _.chain(queryString.replace('?', '').split('&'))
    .map(params => [params.split('=')[0], decodeURIComponent(params.split('=')[1])])
    .fromPairs()
    .value();
}



// WEBPACK FOOTER //
// ./src/toolbox/parseQueryString.js